export * from './home-destaques.component';